import { createIcon } from '@chakra-ui/icons';
import React from 'react';
export const AreaChartIcon = createIcon({
    displayName: 'AreaChartIcon',
    viewBox: '0 0 24 24',
    path: (React.createElement("path", { d: "M13.3519 4.72892L16.8269 7.50007H18.9808C19.4025 7.50007 19.7612 7.64783 20.0567 7.94335C20.3522 8.23885 20.5 8.59749 20.5 9.01927V19.5H3.5V9.8078C3.5 9.4296 3.66571 9.15845 3.99712 8.99435C4.32852 8.83025 4.64487 8.86037 4.94615 9.08472L7.11538 10.7116L11.1692 5.03277C11.4256 4.67509 11.7683 4.4658 12.1971 4.4049C12.6259 4.344 13.0109 4.45201 13.3519 4.72892ZM4.99997 11V14.6L7.99998 17L12 11.5L19 16.95V9.00005H16.3L12.4 5.87505L7.44998 12.825L4.99997 11Z", fill: "currentColor" })),
});
